export default __webpack_public_path__ + "static/media/Medium-branded-DeepRacer-GUI-bordered-450px-288px.jpg.2c9b8acc.webp";